var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"text-h5 font-weight-bold mb-2 text--primary"},[_vm._v("Terminal e Impressão")]),(_vm.$auth.isAdmin())?_c(_setup.ImpressaoTermica):_vm._e(),_c(_setup.Terminal),_c(_setup.TerminalImpressao)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }